import {Product} from '@hconnect/apiclient'
import {Typography} from '@hconnect/uikit'
import {Box} from '@mui/material'
import React from 'react'
import {Controller, UseFormReturn} from 'react-hook-form'

import {useTranslation} from '../../../hooks/useTranslation'
import {WidgetUserCreationFormData} from '../WidgetUserCreation.form'
import {CustomerToggleBasedPermissionKeys} from '../WidgetUserCreation.types'

import {WidgetPermissionInput} from './WidgetPermissionInput'
import {WidgetProductInput} from './WidgetProductInput'

interface WidgetUserProductsPermissionsProps {
  formMethods: UseFormReturn<WidgetUserCreationFormData>
  selectedProducts?: Product[]
  setSelectedProducts: (value: Product[] | undefined) => void
  initPermissions: Record<string, boolean>
  isCreateOrderPermissionSelected: boolean
}

export const WidgetUserProductsPermissions = ({
  formMethods,
  selectedProducts,
  setSelectedProducts,
  initPermissions,
  isCreateOrderPermissionSelected
}: WidgetUserProductsPermissionsProps) => {
  const {t} = useTranslation()

  return (
    <>
      <Typography
        style={{fontSize: '18px', fontWeight: 600, marginBottom: '24px', marginTop: '48px'}}
      >
        {t('widgetUserCreation.form.products.title')}
      </Typography>
      <Box style={{display: 'flex', flexDirection: 'column'}}>
        <WidgetProductInput
          product={Product.Hub}
          selectedProducts={selectedProducts}
          setSelectedProducts={setSelectedProducts}
        />
        <WidgetProductInput
          product={Product.OnSite}
          selectedProducts={selectedProducts}
          setSelectedProducts={setSelectedProducts}
        />
      </Box>
      <Typography
        style={{fontSize: '18px', fontWeight: 600, marginBottom: '24px', marginTop: '48px'}}
      >
        {t('widgetUserCreation.form.permissions')}
      </Typography>
      <Box style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            marginBottom: '24px'
          }}
        >
          {Object.keys(initPermissions).map((key) => (
            <Controller
              key={key}
              name={`permissions.${key as keyof typeof CustomerToggleBasedPermissionKeys}`}
              control={formMethods.control}
              render={({field}) => (
                <WidgetPermissionInput
                  label={t(`widgetUserCreation.form.actionBasedPermissions.${key}`)}
                  data-test-id={`widgetUserCreation-${key}-label`}
                  permissionKey={key}
                  checked={!!formMethods.watch('permissions')[key]}
                  onChange={(checked) => field.onChange(checked)}
                  disabled={
                    (isCreateOrderPermissionSelected &&
                      key === (CustomerToggleBasedPermissionKeys.canChangeOrders as string)) ||
                    (!formMethods.formState.dirtyFields.permissions?.[key] &&
                      !!formMethods.watch('permissions')[key])
                  }
                />
              )}
            />
          ))}
        </Box>
      </Box>
    </>
  )
}
